// umlaut-check: skip — "VorschlagVerwerfenModal" ist ein Komponenten-
// /Dateiname (technischer Bezeichner), bleibt ASCII.

import React, {useState} from "react";
import {Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import {TOOLTIP_POPPER_CONFIG} from "./tooltipConfig.js";

/**
 * Grund-Pflichtfeld beim Verwerfen eines Bestellvorschlags (Auftrag AP9
 * Punkt 2: "verworfen (Grund Pflicht)") - Ersatz für `prompt()`, das im
 * Haus nicht zugelassen ist. Vorbild: Components/Cosmos/BestaetigenModal.jsx.
 */
export default function VorschlagVerwerfenModal({show, artikelname, busy = false, onConfirm, onCancel}) {
    const [grund, setGrund] = useState("");

    const schliessen = () => {
        setGrund("");
        onCancel();
    };

    return (
        <Modal show={show} onHide={schliessen} centered aria-labelledby="cosmos-verwerfen-title">
            <Modal.Header closeButton>
                <Modal.Title id="cosmos-verwerfen-title" style={{fontSize: 16}}>
                    Vorschlag verwerfen{artikelname ? ` – ${artikelname}` : ""}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{fontSize: 14, lineHeight: 1.5}}>
                <p className="text-muted">
                    Der Vorschlag wird als verworfen markiert und bleibt zur Nachvollziehbarkeit stehen. Es wird dabei nichts bestellt oder storniert.
                </p>
                <label className="form-label small mb-1" htmlFor="cosmos-verwerfen-grund">
                    Grund (Pflichtfeld)
                </label>
                <textarea
                    id="cosmos-verwerfen-grund"
                    className="form-control form-control-sm"
                    rows={3}
                    value={grund}
                    onChange={(e) => setGrund(e.target.value)}
                    placeholder="Warum wird dieser Vorschlag verworfen?"
                />
            </Modal.Body>
            <Modal.Footer>
                <OverlayTrigger flip popperConfig={TOOLTIP_POPPER_CONFIG} placement="top" overlay={<Tooltip id="verwerfen-abbrechen-tip">Schließt dieses Fenster, ohne etwas zu ändern.</Tooltip>}>
                    <span>
                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={schliessen}>
                            Abbrechen
                        </button>
                    </span>
                </OverlayTrigger>
                <OverlayTrigger flip popperConfig={TOOLTIP_POPPER_CONFIG} placement="top" overlay={<Tooltip id="verwerfen-bestaetigen-tip">Markiert den Vorschlag als verworfen, mit diesem Grund – bestellt oder storniert nichts.</Tooltip>}>
                    <span>
                        <button type="button" className="btn btn-sm btn-outline-danger" disabled={busy || !grund.trim()} onClick={() => onConfirm(grund.trim())}>
                            {busy ? "wird ausgeführt…" : "Verwerfen"}
                        </button>
                    </span>
                </OverlayTrigger>
            </Modal.Footer>
        </Modal>
    );
}
